
import { ContactAddress } from "@/models/base";
import { DossierConfigService } from "@/services/dossier-config-service";
import { ICountry } from "@/utils/country";
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";
import AppLabel from "@/components/common/InfoInput.vue";
import { UserConfigService } from "@/services/user-config-service";
import AppSendMessageDialog from "@/components/mail/SendMessageDialog.vue";
import { TranslateResult } from "vue-i18n";

export default Vue.extend({
	data(){
		return {
			sendMessageDialogMail: ""
		};
	},
	props: {
		contactAddress: {
			type: Object as () => ContactAddress,
			required: true,
		},
		groupId: {
			type: Number,
			required: true
		}
	},
	computed: {
		lngItems(): ISelectItem<string>[] {
			return this.lngs.map(l => {
				return {
					text: l,
					value: l
				};
			});
		},
		countries(): ICountry[] {
			let lng = UserConfigService.getGeneralSettings().SelectedLang;
			let lngs = require(`@/assets/json/countries/${lng}.json`) as ICountry[];
			return lngs;
		},
		country():string{
			return this.countries.filter(c=>c.code == this.contactAddress.CountryCode).map(c=>c.name)[0] || "";
		},
		matchedCountries(): ICountry[] {
			return this.countries.filter(c => c.name.toLowerCase().match(this.country.toLowerCase()));
		},
		lngs: () => DossierConfigService.getLanguages().LanguageNames,
		mails():string[]{
			return this.contactAddress.Email.split(";");
		}
	},
	methods: {
		openSendMessageModal(mail:string){
			this.sendMessageDialogMail = mail;
		},
		closeSendMessageDialog(){
			this.sendMessageDialogMail = "";
		},
		getMailLabel(i:number):string | TranslateResult{
			return this.contactAddress.getMailLabel(i);
		}
	},
	components: {
		AppLabel,
		AppSendMessageDialog
	},
	i18nEx: {
		componentPrefix: "components.contacts"
	}
});
